<template>
  <div class="container">
    <div v-if="isNotExpr" class="container-div">
      <van-notice-bar v-if="activeIndex == 0"
                      style="margin-top: 2px"
          left-icon="volume-o"
          text="活体授权只能被一个手机授权，请确保除活体验证人本人手机外，不要使用其他手机进行授权！"
      />
      <div v-if="activeIndex == 0" style="display: flex; flex-direction: column; justify-content: space-around;align-items: center;height: 100%;">


        <div class="flex-a-center" style="display: flex; flex-direction: column;align-items: center; justify-content:space-between;" >
          <svg t="1716992749719" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11283" width="80" height="80" data-spm-anchor-id="a313x.search_index.0.i33.55753a81SuAVLf"><path d="M324.0832 624.64l175.36 102.016V522.624l-175.36-102.016V624.64z m376.32 0V420.608l-175.36 102.016v204.032z m-13.0688-226.56l-175.0912-102.016-175.0784 102.016 175.0784 102.016z m-484.3392 83.712a21.8368 21.8368 0 0 0 15.8208-6.656 22.4256 22.4256 0 0 0 6.5408-15.872v-115.968l98.2528-57.344a22.6432 22.6432 0 0 0 1.536-40.832 22.2208 22.2208 0 0 0-23.8976 2.176l-110.3872 63.616a22.6944 22.6944 0 0 0-11.648 19.712v128.64a22.7968 22.7968 0 0 0 7.04 16.512 22.4512 22.4512 0 0 0 16.7424 6.016z m120.6144 254.976l-99.2-57.472v-115.84a22.3616 22.3616 0 1 0-44.7232 0v128.384a22.7456 22.7456 0 0 0 11.1744 19.712l110.3872 63.744a22.2592 22.2592 0 0 0 30.5664-8.192 22.6688 22.6688 0 0 0-8.2048-30.848v0.512z m287.8336 52.224l-99.2 58.368-99.2-57.856a22.1824 22.1824 0 0 0-30.5664 8.32 22.7328 22.7328 0 0 0 8.2048 30.848l110.3872 64.256a21.888 21.888 0 0 0 22.3616 0l110.3744-64.256a22.72 22.72 0 0 0 8.2048-30.848 22.1824 22.1824 0 0 0-30.5664-8.32v-0.512z m210.048-248.192a22.3488 22.3488 0 0 0-15.808 6.656 22.6816 22.6816 0 0 0-6.5536 16v115.84l-99.2 57.856a22.7328 22.7328 0 0 0-5.2096 29.568 22.1568 22.1568 0 0 0 28.5312 8.576l110.3744-64.256A22.7456 22.7456 0 0 0 844.8 691.328v-127.872a23.04 23.04 0 0 0-6.8736-16.384 22.4384 22.4384 0 0 0-16.4352-6.272z m12.1344-229.888l-110.3744-63.616a22.5536 22.5536 0 0 0-22.3616 39.168l99.1872 56.832v115.456a22.3616 22.3616 0 1 0 44.7232 0V330.624a22.592 22.592 0 0 0-11.1744-19.712z m-420.5824-77.312l99.2-58.24 99.2 57.728a22.2464 22.2464 0 0 0 30.5664-8.192 22.656 22.656 0 0 0-8.2048-30.848l-110.3744-63.616a23.8464 23.8464 0 0 0-22.3616 0l-110.3872 64a22.7328 22.7328 0 0 0-8.2048 30.848 22.1824 22.1824 0 0 0 30.5664 8.32z m0 0" fill="#d4237a" p-id="11284" data-spm-anchor-id="a313x.search_index.0.i34.55753a81SuAVLf" class="selected"></path></svg>
          <div style="color: #8d8d8d;margin-top: 30px;text-align: center;font-weight: normal;font-size: 18px">融信数据授权</div>

<!--          <div class="alter-container" >-->
<!--            <div class="alter-text">* 活体授权只能被一个手机授权！</div>-->
<!--            <div class="alter-text">* 请确保除活体验证人本人手机外，不要使用其他手机进行授权！</div>-->
<!--          </div>-->


          <div style="width: 100%">
            <div>
              <h2 class="van-doc-demo-block__title">*请核对认证信息</h2>
              <van-cell-group>
                <van-field v-model="form.userName" style="padding: 10px" label="用户姓名" disabled/>
                <van-field v-model="form.userPhone" style="padding: 10px" label="联系方式" disabled/>
              </van-cell-group>
            </div>
          </div>
        </div>

        <div>
          <div style="display: flex; flex-direction: column; justify-content:center;align-items: center;">
            <div style="display: flex; justify-content:center;align-items: flex-start;">
            <span style="margin-left: 5px; display: flex; align-items: center">
              <van-checkbox v-model="checked" shape="square"></van-checkbox>&nbsp;&nbsp;
              <span>我已阅读并同意<span class="link-text" @click="openAuthFile()">《授权服务协议》</span></span>
            </span>
            </div>
            <span v-show="showErrorMsg" class="error-msg">
            * 请勾选同意授权服务协议
          </span>
          </div>

          <div style="display: flex; justify-content:center; margin-top: 15px">
            <van-button type="primary" class="btn-class" @click="handlerNext">去授权</van-button>
          </div>
        </div>
      </div>


      <div v-else-if="activeIndex == 1">
        <div style="display: flex; justify-content:center;padding: 45px; flex-direction: column;align-items: center;">
          <img class="img-class" src="@/assets/auth-success.png" v-if="success === 2">
          <img class="img-class" src="@/assets/auth-error.png" v-if="success === 3">
          <div style="margin-top: 30px; color: red">{{msg}}</div>
          <van-button type="info" style="margin-top: 50px" v-if="msg" class="btn-class" @click="handlerColsePage">我知道了</van-button>
        </div>
      </div>
    </div>

    <div v-else>
      <van-empty description="链接已过期，请重新申请！" />
    </div>

    <van-popup v-model="showPopup" position="bottom" :style="{ height: '90%' }" >
      <AuthContent></AuthContent>
    </van-popup>
  </div>
</template>

<script>
import {checkExpr, faceCallBack, applyFaceUrl} from "@/api/credit/faceAuth.js"
import {closePage} from "@/utils/page.js"
import { Toast } from 'vant';
import AuthContent from "./authContent.vue"
export default {
  components: {AuthContent},
  data(){
    return {
      showPopup: false,
      showErrorMsg: false,
      uniqKey: null,
      activeIndex: 0,
      form: {
        bizToken: null,
        ruleId: null,
        platform: null,
        faceUrl: null,
        userName: null,
        userPhone: null,
        userCertNo: null,
        flowId: null,
      },
      msg: "",
      success: 1,
      checked:false,
      isNotExpr: true
    }
  },
  mounted() {
    this.initState()
  },
  watch: {
    checked(v){
      if (v){
        this.showErrorMsg = false
      }
    }
  },
  methods:{
    initState(){
      const params = this.$route.query
      const {uniqKey, activeIndex} = params;
      this.activeIndex = activeIndex
      if(uniqKey){
        this.uniqKey = uniqKey
        checkExpr({uniqKey}).then(res => {
          if(res.data){
            const {key, value} = res.data
            this.isNotExpr = key
            this.form = value
          }

          if(this.isNotExpr && this.activeIndex && this.activeIndex =='1'){
            // 回调方法, 验证人脸结果、更新状态
            faceCallBack({uniqKey, flowId: this.form.flowId}).then(res => {
              if (res.data.status === 1){
                if (res.data.creditResult){
                  Toast.success('授权成功');
                  this.msg = "恭喜你，授权成功"
                  this.success = 2
                }else{
                  this.msg = `活体检测成功，授权失败，请联系管理员！`
                  this.success = 3
                }
                // Toast.success('授权成功');
                // this.msg = "恭喜你，授权成功"
                // this.success = 2
              } else if (res.data.status === 2) {
                this.msg = `活体检测失败，请重试！`
                this.success = 3
              }
            }).catch(() => {
              this.msg = "很遗憾，授权失败"
              this.success = 3
            })
          }
        })
      }
    },
    handlerColsePage(){
      closePage()
    },
    openAuthFile(){
      this.showPopup = true
    },
    handlerNext(){
      if (!this.checked){
        this.showErrorMsg = true
        return
      }
      // window.location.href=this.form.faceUrl
      // 请求人脸识别地址
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      const baseUrl = process.env.VUE_APP_BASE_API
      applyFaceUrl({
        uniqKey: this.uniqKey,
        name: this.form.userName,
        idCardNo: this.form.userCertNo,
        faceauthMode: 'TENCENT',
        callbackUrl: `${baseUrl}/faceAuth?uniqKey=${this.uniqKey}&activeIndex=1`,
        contextId: this.uniqKey
      }).then(res => {
        Toast.clear();
        this.form.flowId = res.data.flowId;
        this.form.faceUrl = res.data.originalUrl;
        if (this.form.faceUrl) {
          console.log("🚀 人脸识别链接申请成功: ", this.form.faceUrl);
          window.location.href = this.form.faceUrl
        }
      }).catch(e => {
        console.log("🚀 e: ", e);
        Toast.clear();
      })
    }
  }
}
</script>
<style scoped lang="scss">
.container{
  background: #f7f8fa;
  height: 100vh;
  padding: 30px 10px;

}

.container > div > div{
  width: 100%;
}
.container-div{
  height: 95%;
}
.container-div > div > div{
  width: 98%;
}
.van-doc-demo-block__title{
  padding-top: 20px;
  margin: 0;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.flex-j-center{
  display: flex;
  justify-content: center;
}
.flex-a-center{
  display: flex;
  align-items: center;
}
.btn-class{
  width: 80%;
  border-radius: 30px;
}
.link-text{
  color: #f77122;
}
.alter-container{
  color: #f77122;
  margin-top: 50px;
  font-size: 20px;
}
.alter-text{
  margin-top: 10px;
}
.error-msg{
  display: block;
  color: red;
}
.img-class{
  width: 4rem;
}
::v-deep .van-field__label{
  color: #000 !important;
  font-size: 18px;
}
::v-deep .van-cell{
  line-height: 34px;
}
::v-deep .van-field__control:disabled {
  color: #040404 !important;
  -webkit-text-fill-color: #040404 !important;
  font-size: 18px;
}
.van-doc-demo-block__title{
  color: red;
}
</style>
